import axios, { AxiosResponse } from 'axios';

import { IStoreAssetApiResponse } from 'models/store/i-store-asset-api-response.interface';

import { ASSET_FIELDS, LANDING_FIELDS } from 'constants/params-fields.constant';

export const fetchLandingAssets = (
  tokenIds: number[] | string[],
  additionalFields: string[] = []
): Promise<AxiosResponse<IStoreAssetApiResponse[]>> => {
  const allFields = [...ASSET_FIELDS, ...LANDING_FIELDS, ...additionalFields];
  return axios.get<IStoreAssetApiResponse[]>(`/api/v1/assets/all_assets`, {
    params: { token_ids: tokenIds.join(','), fields: allFields.join(',') },
  });
};
